import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useSunlightOptions() {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchSunlightOptions() {
      try {
        setLoading(true);
        const { data, error } = await supabase
          .from('plants')
          .select('sunlight_requirements')
          .not('sunlight_requirements', 'is', null);

        if (error) throw error;

        // Get unique values and sort them
        const uniqueOptions = Array.from(
          new Set(data.map(p => p.sunlight_requirements))
        ).sort();

        setOptions(uniqueOptions);
      } catch (err) {
        console.error('Error fetching sunlight options:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchSunlightOptions();
  }, []);

  return { options, loading, error };
}